import fromPairs from 'lodash/fromPairs'


export default function getCookie() {
  return fromPairs(document.cookie.split('; ').map(i => i.split('=')))
}
